<template>
    <div class="wallpaper" v-if="show" :style="`margin-left: ${marginLeft}px;z-index: ${zIndex}`" v-touch:tap="hide">
        <img class="wallpaper-img" :src="pic" />
    </div>
</template>

<script>
    import {getMaxScreenHeight, getMaxScreenWidth, GlobalLoading, isHtml5PlusSupported, Styles} from "../../utils";

    export default {
        name: "WallpaperPreviewerImage",
        data(){
            return {
                show: false,
                size: null,
                zIndex: {
                    type: Number,
                    default: 2000
                },
                marginLeft: 0
            }
        },
        created(){
            // 误删，记录：使用下面的方式添加 touchend 事件失败。最终使用了 vue2-touch-events 组件
            // setTimeout(()=>{
            //     console.log('wallpaperPreviewerImage created, this.$el', this.$el);
            //     this.$el.addEventListener('touchend', this.hide);
            // }, 500);
        },
        methods: {
            /**
             * 展示手机壁纸，难点是如何让手机壁纸居中显示，
             * ----------
             * 计算居中的属性，试过 align=center，也不能使得图片居中，目前唯一的办法就是使用 margin-left 使得放大后的图片居中显示
             * 1. 计算出缩放后的 width, stretchWidth
             * 2. 然后减去屏幕的宽度（即是图片最终的展示宽度），剩下的是超出部分，
             * 这种做法现在唯一的一个弊端是，设置以后，如果启用 auto scroll 的话无法 scroll margin-left 的部分。
             */
            display(){
                if(isHtml5PlusSupported()) plus.navigator.setFullscreen(true);
                Styles.disableBodyScroll();
                GlobalLoading.start();
                setTimeout(()=>{
                    let screenHeight = getMaxScreenHeight();
                    let screenWidth = getMaxScreenWidth();
                    console.log(`screen height: ${screenHeight} and screen width: ${screenWidth}`);
                    let stretchHeight = screenHeight;
                    let stretchWidth = ( stretchHeight / this.size.height ) * this.size.width; // 缩放后的 width
                    console.log('the stretch width:', stretchWidth);
                    // 通过设置 marginLeft 值让放大后的图片居中显示
                    this.marginLeft = stretchWidth > screenWidth ? -((stretchWidth - screenWidth) / 2) : 0;
                    console.log('align left:', this.marginLeft);
                    // 展示手机壁纸效果
                    this.show = true;
                    GlobalLoading.stop();
                }, 500); // 300ms for UE
            },
            hide(){
                setTimeout(()=>{
                    this.show = false;
                    this.reset();
                    if(isHtml5PlusSupported()) plus.navigator.setFullscreen(false); // 取消全屏展示
                    Styles.enableBodyScroll();
                }, 300); // 300ms for UE
            },
            reset(){
                this.size = null;
                this.marginLeft = 0;
            }
        }
    }
</script>

<style scoped>
    .wallpaper{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100vh;
        z-index: 2000;
        overflow: hidden;
    }

    .wallpaper-img{
        object-fit: cover;
        height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/WallpaperPreviewerImage.vue